import React, { useState, useCallback } from "react";
import Modal from "react-modal";
import "./css/Modais.css";
import "./css/ModaisMobile.css";
import "./css/Images.css";
import check from "./images/check.svg";
import useClipboard from "react-use-clipboard";
import ButtonX from "../Images/ButtonX.svg";
import checkIcon from "../Toast/Image/check.svg";
import Toast from "../Toast/Toast";
import { useProgress } from "../../hooks/progress";
import { readDataStorage, writeStorage } from "../../utils/storage/storage";
import api from "../../services/api/index";
import { PDFPropostaButton } from "../GeraPDFProposta";

export default function ModalLink({
  isOpen,
  onRequestClose,
  rowIdxVisual,
  calculo,
  mensalidade,
  data,
  detalhamento,
}) {
  const [, /*copy*/ setCopy] = useClipboard(rowIdxVisual);
  const {
    IdCard,
  } = readDataStorage("login");
  const [isClose] = useState(false);
  const { setLoad } = useProgress();

  const [list, setList] = useState([]);

  let toastProperties = null;
  const showToast = (type) => {
    const id = Math.floor(Math.random() * 101 + 1);

    switch (type) {
      case "success":
        toastProperties = {
          id,
          title: "",
          description: "Link copiado para área de transferência!",
          backgroundColor: "#5cb85c",
          icon: checkIcon,
        };
        break;
      default:
        setList([]);
    }

    setList([...list, toastProperties]);
  };

  const handleClick = () => {
    setCopy();
    showToast("success");
  };

  const setDados = useCallback(
    async ({ id }) => {
      setLoad(true);
      api.defaults.headers.common = {
        Authorization: `bearer ${sessionStorage.getItem("@ARP-Energia:token")}`,
      };
      await api.get(`/csp/representante/cards/consultar?idCard=${id}`)
        .then((res) => {
          if (res.status === 200) {
            setLoad(false);
            const removeItem = (arr, refId) => {
              return arr.filter(function (i) {
                return i.situa_o_arp !== refId;
              });
            };
            const arr = removeItem(res.data["cards"], "inativo");

            writeStorage({
              key: "dados",
              object: {
                Cards: arr,
              },
            });
            window.location.href = "/arp/";
          }
        })
        .catch((error) => {
          if (error.response.status === "404" || "500") {
            window.location.href = "/arp/";
          }

          setLoad(false);
        });
    },
    [setLoad]
  );

  const handleBack = useCallback(async () => {
    if (IdCard) {
      await setDados({ id: IdCard });
      onRequestClose();
    }
  }, [setDados, onRequestClose]);
  function numberPoint(numero) {
    // eslint-disable-next-line
    var numero = numero.toFixed(2).split(".");
    numero[0] = numero[0].split(/(?=(?:...)*$)/).join(".");
    return numero.join(",");
  }
  return (
    <>
      <Toast toastList={list} autoDelete={true} />
      <Modal
        isOpen={isOpen}
        onRequestClose={() => {
          if (isClose === true) {
            onRequestClose();
          }
        }}
        contentLabel="Modal"
        style={{ outline: 0 }}
        ariaHideApp={false}
        className={{
          base: "modal-base",
          afterOpen: "modal-base_after-open",
          beforeClose: "modal-base_before-close",
        }}
        overlayClassName={{
          base: "overlay-base",
          afterOpen: "overlay-base_after-open",
          beforeClose: "overlay-base_before-close",
        }}
        shouldCloseOnOverlayClick={true}
      >
        <div className="imgX" id="btnXModalGPCR" onClick={handleBack}>
          <img alt={""} src={ButtonX}></img>
        </div>
        <img className="imgCheck" alt={""} src={check}></img>
        <div className="modalTitle">Sua proposta foi gerada!</div>
        <br />
        <div className="modalSubTitle">
          A <b>economia anual prevista</b> para esse valor será de R${" "}
          {numberPoint(Number(calculo))}
        </div>
        <br />
        <div className="modalSubTitle">
          O valor da <b>mensalidade</b> será de R${" "}
          {numberPoint(Number(mensalidade))}
        </div>
        <br />
        <div className="modalTtext">
          Envie o link da proposta para o cliente agora mesmo ou acesse as
          informações novamente através da Biblioteca.
        </div>
        <br />
        <div className="form-group disablemobile" onClick={handleClick}>
          <input
            className="form-field"
            type="text"
            placeholder="Link"
            defaultValue={rowIdxVisual}
            disabled
          ></input>
          <span>Copiar link da proposta</span>
        </div>
        <br></br>
        <div className="form-group">
          <PDFPropostaButton
            data={data}
            detalhamento={detalhamento}
            detalhamentoEconomia={numberPoint(Number(calculo))}
            mensalidade={numberPoint(Number(mensalidade))}
            urlDoLinkProsseguirAssinatura={rowIdxVisual}
          />
        </div>
      </Modal>
    </>
  );
}